export const SHOW_SAVE_TEAM_TOAST = "SHOW_SAVE_TEAM_TOAST";

export function showSavedToast(shouldShow) {
  return {
    type: SHOW_SAVE_TEAM_TOAST,
    payload: shouldShow
  };
}
